import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { Reveal } from "./Reveal";
import { CONTACT } from "../data/site";

export const DevisCTA = ({ title = "Un projet ? Demandez votre devis.", text = "Décrivez votre besoin, nous vous répondons rapidement." }) => (
  <section className="max-w-[1400px] mx-auto px-6 md:px-12 py-20 md:py-28">
    <Reveal className="relative overflow-hidden rounded-[2rem] bg-forest text-sand px-8 md:px-16 py-14 md:py-20 grain">
      <div className="relative flex flex-col lg:flex-row lg:items-center justify-between gap-8">
        <div className="max-w-xl">
          <h2 className="font-display text-3xl md:text-5xl tracking-tight leading-[1.05]">{title}</h2>
          <p className="mt-4 text-sand/75">{text}</p>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 shrink-0">
          <Link to="/contact" data-testid="section-devis-btn" className="inline-flex items-center justify-center gap-2 bg-olive text-white rounded-full px-8 py-4 font-semibold hover:bg-olive-hover transition-all hover:-translate-y-1">
            Demander un devis <ArrowRight size={18} />
          </Link>
          <a href={`tel:${CONTACT.phone}`} className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-sand/40 px-8 py-4 font-semibold hover:bg-sand/10 transition-all">
            <Phone size={16} /> {CONTACT.phoneDisplay}
          </a>
        </div>
      </div>
    </Reveal>
  </section>
);
